<template>
    <div ref="usersListContainer" class="container mb-5">

        <div class="k-tabs">
            <ul class="k-tabs__list">
                <li class="k-tabs__item k-tabs__item--active">
                    <span class="k-tabs__link k-tabs__list--nohover"><slot v-slot:title></slot></span>
                </li>
            </ul>

            <div class="k-tabs__sorting">
                <span class="k-tabs__sorting-text">Řadit podle:</span>

                <select @change="sortChanged" v-model="orderBy" ref="sortSelect1" class="form-control">
                    <option value="name">Jména</option>
                    <option value="branch">Pobočky</option>
                </select>


                <select @change="sortChanged" v-model="orderDirection" ref="sortSelect2" class="form-control">
                    <option value="asc">Vzestupně</option>
                    <option value="desc">Sestupně</option>
                </select>
            </div>
        </div>


        <transition-group name="list-complete" tag="div" class="row">
                <div v-for="user in users.data" :key="user.id" class="col-3 k-mb-30">
                    <div class="k-panel k-panel--equal-height">
                        <div class="k-panel__body p-0 text-center">

                            <div class="k-user">
                                <div class="k-user__image">
                                    <img class="k-user__image-el" :src="user.prev_url">
                                </div>


                                <a class="k-user__name" :href="user.detail_url">
                                    <h3 class="k-h-tertiary">
                                        {{ user.name }}
                                    </h3>
                                </a>

                                <div class="k-user__info">
                                    <div v-if="user.phone" >{{ user.phone }}</div>
                                    <div v-if="user.branch_office">{{ user.branch_office }}</div>
                                </div>

                            </div>
                        </div>

                        <div class="k-panel__footer">

                            <a :href="user.detail_url" class="k-action k-action--control k-panel__footer-btn text-center">Profil</a>

                            <a v-if="user.edit_url" :href="user.edit_url" class="k-action k-action--control text-center k-panel__footer-btn k-panel__footer-btn--bl">Upravit</a>

                        </div>
                    </div>
                </div>
                <div v-if="users.data && users.data.length === 0" :key="0" class="col-12">
                    <div class="k-panel">
                        <div class="k-panel__body p-3 justify-content-center text-center">
                            Nebyl nalezen žádný uživatel.
                        </div>
                    </div>
                </div>
        </transition-group>

        <pagination :data="users" @pagination-change-page="paginate"></pagination>

    </div>
</template>

<script>
    import Choices from 'choices.js';
    import Pagination from 'laravel-vue-pagination';

    export default {

        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            }
        },

        data: () => ({
            users: {},
            orderBy: 'name',
            orderDirection: 'asc',
            search: ''
        }),

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            orderBy: this.orderBy,
                            orderDirection: this.orderDirection,
                            search: this.search
                        }
                    });

                    if (result.status === 200 && result.data) {
                        this.users = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Paginate results
             *
             * @param page
             * @returns void
             */
            paginate: async function(page = 1) {
                await this.getData(page);
                if (this.$refs.usersListContainer) {
                    setTimeout( () => {
                        this.$scrollTo(this.$refs.usersListContainer, 500, {offset: -80});
                    }, 300);
                }
            },

            /**
             * Sort changed event handler
             *
             * @returns void
             */
            sortChanged() {
                this.getData();
            }
        },

        created() {
            // listen for search input event
            window.events.$on('searchInputSubmitted', async (search) => {
                this.search = search;
                this.paginate(1);
            });
        },

        mounted() {
            // get table data
            this.getData();

            // register choices
            let selects = [
                this.$refs.sortSelect1,
                this.$refs.sortSelect2
            ];

            for (let sort of selects) {
                new Choices(sort, {
                    classNames: {
                        containerOuter: 'choices k-sort-select-choices',
                        containerInner: 'choices__inner',
                        input: 'choices__input',
                        inputCloned: 'choices__input--cloned',
                        list: 'choices__list',
                        listItems: 'choices__list--multiple',
                        listSingle: 'choices__list--single',
                        listDropdown: 'choices__list--dropdown',
                        item: 'choices__item',
                        itemSelectable: 'choices__item--selectable',
                        itemDisabled: 'choices__item--disabled',
                        itemChoice: 'choices__item--choice',
                        placeholder: 'choices__placeholder',
                        group: 'choices__group',
                        groupHeading: 'choices__heading',
                        button: 'choices__button',
                        activeState: 'is-active',
                        focusState: 'is-focused',
                        openState: 'is-open',
                        disabledState: 'is-disabled',
                        highlightedState: 'is-highlighted',
                        hiddenState: 'is-hidden',
                        flippedState: 'is-flipped',
                        loadingState: 'is-loading',
                        noResults: 'has-no-results',
                        noChoices: 'has-no-choices'
                    },
                    callbackOnInit: function() {
                        let el = this.containerInner.element;
                        el.style.width = (el.getBoundingClientRect().width + 10) +  'px';
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity 0.5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }
</style>
